import { Button } from '@upmc/ims.component-library';
import { RemoveWQSystem, GetWQSystems } from '../../../_api';
import RemoveWQSystemRequest from '../../../../../Classes/ResponseModels/ApplicationManagement/RemoveWQSystemRequest';
import { useState } from 'react';

const DeactivateAppSystem = ({
	system,
	setAppSystems,
	app,
	appID,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	const [removing, setRemoving] = useState(false);

	const handleClick = () => {
		const request = new RemoveWQSystemRequest(
			currentUser,
			requirementNumber,
			app
		);
		request.system = system;
		setRemoving(true);
		RemoveWQSystem(request).then(resp => {
			if (resp) {
				GetWQSystems(appID)
					.then(response => {
						setAppSystems(response);
					})
					.then(setRemoving(false));
			}
		});
	};

	return (
		<Button onClick={handleClick} disabled={readOnly || removing}>
			Remove
		</Button>
	);
};

export default DeactivateAppSystem;
